window.monitoringOnlineFormatter = function(value) {
    let html = '';
    switch (parseInt(value, 10)) {
        case 0:
            html += '<i class="fas fa-circle text-danger animation-blinker"></i>';
            break;
        case 1:
            html += '<i class="fas fa-circle text-success"></i>';
            break;
        default:
            html += '<i class="fas fa-circle text-light"></i>';
            break;
    }
    return html;
};
